export default __webpack_public_path__ + "static/media/logo-callswitch-color.45cc59ec.svg";